import Recipe from '../../../models/recipe'
const state = () => ({
    tabStatus: false,
    activeWorkout: '',
    ingredients: [],
    units: [],
    showIngredientsModal: false,
    categories: [],
    currentRecipe: Recipe,
    fieldOptions: {},
    recipeList: [],
    dietaryOptions: [],
    currentRecipeErrors: {},
    currentIngredient: {
        name: '',
        unit: null,
        image: ''
    },
    currentIngredientMode: "create",
    ingredientItemNumericQuantity: [],
    users: [],
    recipesOptions: [],
})

export default state
